import {
  type ComponentPropsWithoutRef,
  type KeyboardEvent,
  type ReactNode,
} from 'react';

import cx from 'classnames';
import { Link } from 'react-router';

import styles from './ViewLink.module.scss';
import { FullTextTooltip } from '@/components/ui/FullTextTooltip';

interface ViewLinkProps extends Omit<
  ComponentPropsWithoutRef<typeof Link>,
  'to' | 'onClick' | 'onDoubleClick' | 'onKeyDown'
> {
  to: string;
  isCurrentActiveView?: boolean;
  hasUnsavedChanges?: boolean;
  onSelect?: () => void;
  onDoubleClick?: () => void;
  onKeyboardDelete?: (e: KeyboardEvent<HTMLAnchorElement>) => void;
  children: ReactNode;
}

export const ViewLink = ({
  to,
  isCurrentActiveView,
  hasUnsavedChanges,
  onSelect,
  onDoubleClick,
  onKeyboardDelete,
  children,
  ...props
}: ViewLinkProps) => (
  <FullTextTooltip>
    <Link
      to={to}
      data-view-link-active={isCurrentActiveView || undefined}
      className={cx(styles.Link, { [styles.Active]: isCurrentActiveView })}
      onClick={(e) => {
        if (!onSelect) {
          return;
        }
        e.preventDefault();
        onSelect();
      }}
      onDoubleClick={onDoubleClick}
      onKeyDown={(e) => {
        if (e.key === 'Delete' || e.key === 'Backspace') {
          e.preventDefault();
          onKeyboardDelete?.(e);
        }
      }}
      {...props}
    >
      {isCurrentActiveView && hasUnsavedChanges && (
        <span className={styles.UnsavedIndicator}>*</span>
      )}
      <span className={styles.LinkInner}>{children}</span>
    </Link>
  </FullTextTooltip>
);
